import * as React from "react"
import { Input } from "./input"
import * as PropTypes from 'prop-types'

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  hasError?: boolean;
}


const PasswordInput = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, hasError, ...props }, ref) => {

    const [showPassword, setShowPassword] = React.useState(false)
    return (
      <div className="relative">
        <Input
          className={className}
          type={showPassword ? 'text' : 'password'}
          hasError={hasError}
          ref={ref}
          {...props}
        />
        <div
          className="absolute right-2 top-3 text-sm text-accent underline font-semibold cursor-pointer"
          onClick={() => { setShowPassword(!showPassword); }}
        >
          {showPassword ? 'Hide' : 'Show'}
        </div>
      </div>
    )
  }
)
PasswordInput.displayName = "PasswordInput"

PasswordInput.propTypes = {
  className: PropTypes.string,
  hasError: PropTypes.bool
}

export { PasswordInput }
